import React from "react";
import { MapPin, Phone, Mail, Plane, Train, Navigation } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { venue } from "../mock";
import { useReveal } from "../hooks/useReveal";

const distIcon = (place) => {
  if (place.toLowerCase().includes("airport")) return Plane;
  if (place.toLowerCase().includes("railway") || place.toLowerCase().includes("station")) return Train;
  return Navigation;
};

const Venue = () => {
  useReveal();
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(venue.mapQuery)}&output=embed`;
  return (
    <div>
      <PageHeader title="Venue" crumb="Venue" subtitle={venue.name} />
      <section className="section-pad bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-10 items-stretch">
          <div className="reveal">
            <div className="rounded-3xl overflow-hidden shadow-xl"><img src={venue.image} alt={venue.name} className="w-full h-72 object-cover" /></div>
            <h2 className="mt-6 font-display font-extrabold text-2xl text-navy-900">{venue.name}</h2>
            <p className="mt-3 text-slate-600 leading-relaxed">{venue.description}</p>
            <div className="mt-6 space-y-3">
              <div className="flex items-start gap-3"><MapPin className="w-5 h-5 text-brand mt-0.5 shrink-0" /><span className="text-slate-700">{venue.address}</span></div>
              <div className="flex items-center gap-3"><Phone className="w-5 h-5 text-brand shrink-0" /><span className="text-slate-700">{venue.phone}</span></div>
              <div className="flex items-center gap-3"><Mail className="w-5 h-5 text-brand shrink-0" /><span className="text-slate-700">{venue.email}</span></div>
            </div>
          </div>
          <div className="reveal flex flex-col gap-6">
            <div className="rounded-3xl overflow-hidden shadow-xl border border-slate-100 h-72">
              <iframe title="Venue Map" src={mapSrc} className="w-full h-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
            <div className="bg-navy-800 text-white rounded-3xl p-6">
              <h3 className="font-display font-bold mb-4">Distance from Key Locations</h3>
              <div className="space-y-4">
                {venue.distances.map((d) => {
                  const Icon = distIcon(d.place);
                  return (
                    <div key={d.place} className="flex items-center gap-4">
                      <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center shrink-0"><Icon className="w-5 h-5 text-brand" /></div>
                      <div className="flex-1"><div className="font-semibold text-sm">{d.place}</div><div className="text-xs text-slate-400">{d.info}</div></div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Venue;
